import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Genbook tabs state
  openGenbookTabs: [],       // Array of tab objects: { genbookId, adaptationId, generationId, tabId, genbookType, genbook_name, fabric_id, fabric_name, is_initialized }
  activeTabId: null,          // Currently active tab ID
  genbookDataCache: {},       // Maps `tab_${tabId}` -> { outcomesData, reportsData, loadedAt }

  // Per-tab UI state
  tabActiveViews: {},         // Maps tabId -> 'outcomes' | 'reports'
};

const genbookSlice = createSlice({
  name: 'genbook',
  initialState,
  reducers: {

    // ── Genbook Tabs ───────────────────────────────────────
    addGenbookTab(state, action) {
      state.openGenbookTabs.push(action.payload);
    },

    removeGenbookTab(state, action) {
      const tabId = action.payload;
      state.openGenbookTabs = state.openGenbookTabs.filter(
        (tab) => tab.tabId !== tabId
      );
      delete state.genbookDataCache[`tab_${tabId}`];
      delete state.tabActiveViews[tabId];

      // If closing the active tab, switch to last remaining tab
      if (state.activeTabId === tabId) {
        const remaining = state.openGenbookTabs;
        state.activeTabId =
          remaining.length > 0 ? remaining[remaining.length - 1].tabId : null;
      }
    },

    setActiveTabId(state, action) {
      state.activeTabId = action.payload;
    },

    // ── Genbook Data Cache ─────────────────────────────────
    updateGenbookDataCache(state, action) {
      const { cacheKey, data } = action.payload;
      state.genbookDataCache[cacheKey] = data;
    },

    setGenbookDataCacheFull(state, action) {
      state.genbookDataCache = action.payload;
    },

    // ── Per-Tab Views ──────────────────────────────────────
    setTabActiveView(state, action) {
      const { tabId, view } = action.payload;
      state.tabActiveViews[tabId] = view;
    },

    // ── Reset ──────────────────────────────────────────────
    resetGenbookState() {
      return initialState;
    },
  },
});

export const {
  addGenbookTab,
  removeGenbookTab,
  setActiveTabId,
  updateGenbookDataCache,
  setGenbookDataCacheFull,
  setTabActiveView,
  resetGenbookState,
} = genbookSlice.actions;

export default genbookSlice.reducer;